<template>
  <!-- 顶部菜单 -->
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <!-- 顶部菜单项 -->
      <router-link
        v-for="tag in visitedViews"
        :key="tag.url"
        :class="isActive(tag)?'active':''"
        :to="tag.url"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag)?closeSelectedTag(tag):''"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        <span class="tag-text">{{ tag.title }}</span>
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="closeSelectedTag(selectedTag)">关闭标签</li>
      <li @click="closeOtherTags(selectedTag)">关闭其他标签</li>
      <li @click="closeAllTags()">关闭全部标签</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPane'

export default {
  name: 'TagsView',
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      start: 0,
      end: 8
    }
  },
  computed: {
    // 标签集 - 保留原有的分页逻辑
    visitedViews() {
      const a = this.$store.state.tagsView.visitedViews
      return this.newVisitedViews(a)
    },
    // 菜单集
    menus() {
      return this.$store.getters.menus
    }
  },
  watch: {
    $route() {
      this.addTags()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  created() {
    this.initTags()
    this.addTags()
  },
  mounted() {
    // 原有的挂载逻辑
  },
  methods: {
    // 判断是否为活跃标签
    isActive(route) {
      return route.url === this.$route.fullPath
    },
    isAffix(tag) {
      return tag.affix
    },
    // 添加标签 - 保留原有逻辑
    addTags() {
      const menu = this.$store.state.tagsView.visitedViews
      if (menu.name) {
        this.$store.dispatch('tagsView/addView', menu)
      }
      return false
    },
    initTags() {
      const menuList = [
        {
          affix: "true",
          code: "T001",
          name: "操作看板",
          url: "/home"
        }
      ]
      menuList.forEach(menu => {
        this.$store.dispatch('tagsView/addVisitedView', menu)
      })
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    },
    // 关闭当前标签 - 保留原有逻辑
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    // 关闭所有标签 - 保留原有逻辑
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews')
    },
    // 关闭其他标签 - 保留原有逻辑
    closeOtherTags(view) {
      this.$store.dispatch('tagsView/delOthersViews', view)
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.url)
      } else {
        if (view.name === 'Dashboard') {
          this.$router.replace({ path: '/redirect' + view.fullPath })
        } else {
          this.$router.push('/')
        }
      }
    },
    // 右键打开菜单 - 保留原有逻辑
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left
      const offsetWidth = this.$el.offsetWidth
      const maxLeft = offsetWidth - menuMinWidth
      const left = e.clientX - offsetLeft + 15

      if (left > maxLeft) {
        this.left = maxLeft
      } else {
        this.left = left
      }

      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    handleScroll() {
      this.closeMenu()
    },
    // 分割数据 - 保留原有的分页逻辑
    newVisitedViews(list) {
      const newList = list.slice(this.start, this.end)
      return newList
    },
    changePageNum(i) {
      if (i[0] === 1) {
        if (this.start === 0) {
          return
        }
        const newList = this.$store.state.tagsView.visitedViews.slice(this.start - 8, this.start)
        this.end = this.start
        this.start = this.end - 8
        this.visitedViews = newList
      } else {
        if (((this.end + 8) - this.$store.state.tagsView.visitedViews.length) > 8) {
          return
        }
        const newList = this.$store.state.tagsView.visitedViews.slice(this.end, this.end + 8)
        this.start = this.end
        this.end = this.start + 8
        this.visitedViews = newList
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 40px;
  width: 100%;
  // background: #FFFFFF;
  display: flex;
  align-items: center;

  .tags-view-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    .tags-view-item {
      display: inline-flex;
      align-items: center;
      padding: 5px 12px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 4px;
      font-weight: normal;
      font-size: 14px;
      color: #1D2129;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      text-decoration: none;
      border: 1px solid transparent;
      white-space: nowrap;
      flex-shrink: 0;
      transition: all 0.3s ease;
      margin-right: 8px; /* 增加标签间距 */

      .tag-text {
        flex: 1;
      }

      &:first-of-type {
        margin-left: 8px; /* 第一个标签左边距 */
      }

      &:last-of-type {
        margin-right: 8px; /* 最后一个标签右边距 */
      }

      &.active {
        border: 1px solid #165DFF;
        color: #165DFF;
        background-color: #FFFFFF;
      }

      &:hover {
        background: #f5f7fa;
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 0 0 8px 0 rgba(232,237,250), 0 2px 4px 0 rgba(232,237,250);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
}

// 关闭按钮样式
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      margin-left: 6px; /* 增加关闭图标左边距 */
      width: 16px;
      height: 16px;
      border-radius: 50%;
      text-align: center;
      line-height: 16px;
      font-size: 12px;
      transition: all 0.3s ease;

      &:hover {
        background-color: #b4bccc;
        color: #FFFFFF;
      }
    }
  }
}
</style>
